<template>
  <div class="InvalidPaymentProfile">
    <div class="InvalidPaymentProfile_title">
      <p>
        {{ content }}
      </p>
      <p class="btn" v-if="showButton">
        <router-link
          class="AppButton button-orange"
          :to="{ path: '/my-account/payment-details' }">{{ $t('myaccount.paymentDetails.button', 'Change payment method') }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'invalid-payment-profile',

    props: {
      showButton: {
        type: Boolean,
        default: true
      },
      content: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss">
  .InvalidPaymentProfile {
    border: .01rem solid #de7815;
    background-color: #fdf5d7;
    margin-bottom: .3rem;

    @include media(tablet) {
      margin-top: -.22rem;
    }

    &_title {
      padding: .15rem .16rem .25rem;
      color: #de7815;

      p {
        font-size: .16rem;
        line-height: .22rem;

        &.btn {
          margin-top: 0.2rem;
        }
      }
    }
  }
</style>
